
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"25","viewBox":"0 0 136 136"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M68 0c37.555 0 68 30.445 68 68s-30.445 68-68 68S0 105.555 0 68 30.445 0 68 0zm0 5C33.206 5 5 33.206 5 68s28.206 63 63 63 63-28.206 63-63S102.794 5 68 5zm5.1 28.479v5l-12.618-.001-12.205 16.53a13.618 13.618 0 016.906 9.429l38.638-.297.038 5-38.66.298a13.613 13.613 0 01-6.394 9.214l11.678 15.816 12.617-.001v5H57.96L43.895 80.423c-.676.103-1.37.157-2.075.157-7.511 0-13.6-6.089-13.6-13.6 0-7.511 6.089-13.6 13.6-13.6.47 0 .933.024 1.39.07L57.96 33.48H73.1zM41.82 58.38a8.6 8.6 0 100 17.2 8.6 8.6 0 000-17.2z","fill-rule":"nonzero"}}),_c('circle',{attrs:{"transform":"rotate(90 93.84 66.98)","cx":"93.84","cy":"66.98","r":"10.2"}}),_c('circle',{attrs:{"transform":"rotate(90 77.18 35.7)","cx":"77.18","cy":"35.7","r":"10.2"}}),_c('circle',{attrs:{"transform":"scale(1 -1) rotate(90 175.44 0)","cx":"77.18","cy":"98.26","r":"10.2"}})])])
          )
        }
      }
    